import React from 'react';
import { useTranslation } from 'next-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TabBox from '../organisms/TabBox';
import { Venue } from '../../graphql/types';
import VenueListed from '../molecules/VenueListed';

interface VenuesListProps {
  data: Venue[];
}

const VenuesList = (props: VenuesListProps) => {
  const { data } = props;
  const { t } = useTranslation(['common', 'venue']);

  return (
    <>
      <br />
      <br />
      <Row>
        <Col xs={8}>
          <TabBox
            mobileSlide
            full
            title={t('venue:otherVenues:headline')}
            tabs={[]}
          >
            {data.map((data, idx) => (
              <VenueListed data={data} key={idx} />
            ))}
          </TabBox>
        </Col>
      </Row>
    </>
  );
};

export default VenuesList;
